import React from 'react';
import WinXP from 'WinXP';

// Using global config

const App = () => {
  return <WinXP />;
};

export default App;
